"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsPolygon = void 0;
const class_validator_1 = require("class-validator");
function between(value, min, max) {
    return min <= value && value <= max;
}
let IsPolygon = class IsPolygon {
    constructor() {
        this.errors = [];
    }
    validate(values) {
        this.errors = [];
        for (const value of values) {
            const long = value[0];
            const lat = value[1];
            if (value.length !== 2)
                this.errors.push(`coordinates ${value} should contain a longitude and a latitude`);
            if (typeof long !== 'number')
                this.errors.push(`longitude ${long} should be a number`);
            if (typeof lat !== 'number')
                this.errors.push(`latitude ${lat} should be a number`);
            if (!between(long, -180, 180))
                this.errors.push(`longitude ${long} is out of range`);
            if (!between(lat, -90, 90))
                this.errors.push(`latitude ${lat} is out of range`);
        }
        return this.errors.length === 0;
    }
    defaultMessage() {
        return this.errors.join('; ');
    }
};
IsPolygon = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: 'IsPolygon', async: false })
], IsPolygon);
exports.IsPolygon = IsPolygon;
